import { onEnterPressed } from "~/src/helpers/accessibilityHelpers";

type InputLabelProps = {
  for?: string;
  label: string;
  onClick: () => void;
  isError?: boolean;
  hasValue?: boolean;
  isOnDarkBg?: boolean;
};

const InputLabel = (props: InputLabelProps) => {
  return (
    <label
      htmlFor={props.for}
      className={`${
        props.isOnDarkBg
          ? "text-ldir-blue-paler"
          : props.isError
            ? "text-ldir-red-900"
            : "text-ldir-brown-900"
      } text-xl mb-px`}
      onClick={props.onClick}
      onKeyDown={(e) => onEnterPressed(e, props.onClick)}
    >
      {props.label}
    </label>
  );
};

export default InputLabel;
